import { Grid2 } from "@mui/material";
import ModifyPlanStyle from "../ModifyPlans/ModifyPlanStyle.module.scss";
import { useEffect, useState } from "react";
import PlanCard from "../../Components/PlanCard/PlanCard";
import SelectPlan from "../SelectPlan/SelectPlan";
import { useSelector } from "react-redux";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { lastSegmentPath } from "../../../../../../Utils/roconConstants";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ModifyPlan = () => {
  const navate = useNavigate();
  const [showModifyPlanPage, setShowModifyPlanPage] = useState(false);
  const [selectedGrid, setSelectedGrid] = useState(null);

  const specificPlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );

  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated,
  );

  const basePlan = specificPlan?.find((plan) => plan.basePlan === true);
  let isProcessingCashfree = useSelector(
    (state) => state.plansInfo?.specificPlan,
  );

  const [view, setView] = useState(basePlan?.billingType || "Yearly");
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg,
  );
  const userDetails = useSelector((state) => state.users?.userDetails);
  const country = selectedOrg?.country || userDetails?.country;
  const params = useParams();
  let orgId = parseInt(params.orgId);

  const handleViewToggle = (selectedView) => {
    setView(selectedView);
  };

  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleUpdateClick = (plan) => {
    setSelectedPlan(plan);
  };

  const handleGridSelect = (title) => {
    setSelectedGrid(title);
    setShowModifyPlanPage(true);
  };

  const handleBackToSelect = () => {
    setShowModifyPlanPage(false);
    setSelectedGrid(null);
  };

  useEffect(() => {
    if (basePlan && dedicatedHosting === true) {
      setSelectedGrid("Dedicated Hosting");
      setShowModifyPlanPage(true);
    } else if (basePlan && dedicatedHosting === false) {
      setSelectedGrid("Kubernetes Hosting");
      setShowModifyPlanPage(true);
    } else {
      setShowModifyPlanPage(false);
      setSelectedGrid(null);
    }
  }, [dedicatedHosting]);

  const loading = useSelector((state) => state?.plansInfo?.allPlans);
  const plansInfo = useSelector((state) => {
    const plans = state?.plansInfo?.allPlans?.plans;
    if (selectedGrid === "Dedicated Hosting") {
      return plans?.dedicatedPlans;
    }
    return plans?.licenses;
  });

  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.SET_BILL_DETAILS,
      data: { orgId: orgId, paymentPage: lastSegment },
    });
  });

  const plansDetails = () => {
    const processLicenses = (isSingleSite) => {
      return (
        plansInfo?.filter(
          (item) =>
            (item.singleSitePlan === isSingleSite ||
              item.isSingleSitePlan === isSingleSite) &&
            item.licenseType,
        ) ||
        [].map((item) => ({
          licenseType: item.licenseType,
          features:
            item.features?.map((cat) => ({
              category: cat.category,
              label: cat.label,
              limit: cat.limitOrAvailablity,
              type: cat.type,
            })) || [],
          pricing: item.pricing || [],
        }))
      );
    };

    const extractPricing = (licenseType) => {
      return licenseType.flatMap((price) => {
        const baseFeatureData =
          price?.features
            ?.filter((cat) => cat.category === "Base Feature")
            .map(({ limitOrAvailablity, label }) => ({
              limit: limitOrAvailablity,
              label,
            })) || [];

        // Extract limits for various features
        const numSitesFeature = price.features?.find(
          (feature) => feature.type === "NUM_SITES",
        );
        const numSitesLimit = numSitesFeature
          ? numSitesFeature.limitOrAvailablity
          : null;

        const visitsFeature = price.features?.find(
          (feature) => feature.type === "VISITS",
        );

        const visitsLimit = visitsFeature ? "Unlimited" : null;

        const storageFeature = price.features?.find(
          (feature) => feature.type === "STORAGE",
        );
        const storageLimit = storageFeature
          ? storageFeature.limitOrAvailablity === "Unlimited"
            ? storageFeature.limitOrAvailablity
            : storageFeature.limitOrAvailablity + " GB"
          : null;

        const bandwidthFeature = price.features?.find(
          (feature) => feature.type === "BANDWIDTH",
        );

        const bandwidthLimit = bandwidthFeature
          ? bandwidthFeature.limitOrAvailablity === "Unlimited"
            ? bandwidthFeature.limitOrAvailablity
            : storageFeature.limitOrAvailablity + " GB"
          : null;

        const backupFeature = price.features?.find(
          (feature) => feature.type === "BACKUP_RETENTION",
        );
        const backupLimit = backupFeature
          ? backupFeature.limitOrAvailablity === "Unlimited"
            ? backupFeature.limitOrAvailablity
            : backupFeature.limitOrAvailablity + " Days"
          : null;

        return price.pricing.map((pricingInfo) => ({
          licenseType: price.licenseType,
          priority: price.priority,
          isSingleSitePlan: price.isSingleSitePlan,
          billingType: pricingInfo.billingType,
          originalPrice: pricingInfo.originalprice,
          stripePriceId: pricingInfo.stripePriceId,
          orginalPrice_INR: pricingInfo.orginalPrice_INR,
          salePriceInr: pricingInfo.salePriceInr,
          baseFeatureData,
          numSitesLimit,
          visitsLimit,
          storageLimit,
          bandwidthLimit,
          backupLimit,
        }));
      });
    };

    const licenseFalseType = processLicenses(false);
    const licenseTrueType = processLicenses(true);

    const pricingTrue = extractPricing(licenseTrueType);
    const pricingFalse = extractPricing(licenseFalseType);

    licenseTrueType.sort((a, b) => a.priority - b.priority);
    licenseFalseType.sort((a, b) => a.priority - b.priority);

    pricingTrue.sort((a, b) => a.priority - b.priority);
    pricingFalse.sort((a, b) => a.priority - b.priority);

    return {
      licenseFalseType,
      licenseTrueType,
      pricingTrue,
      pricingFalse,
    };
  };

  const planDetailsResult = plansDetails();

  useMakeApiCalls(() => {
    getStore().dispatch({ type: Actions.API_ALL_PLANS });
    getStore().dispatch({ type: Actions.API_GET_ALL_LICENSE });
  });

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
  }, [orgId]);

  useEffect(() => {
    if (basePlan?.billingType) {
      setView(basePlan.billingType);
    }
  }, [basePlan]);

  const singleSitePlans = plansInfo
    ?.filter((plan) => plan.isSingleSitePlan === true)
    ?.sort((a, b) => a.priority - b.priority);

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });
  const ActivatePopup = (type, message) => {
    if (type === "info") {
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Unlock the Best Plans for Your Needs!",
        popupSubtitle:
          "Reach out to connect@roconpaas.com for exclusive offers!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Plan Downgrade Unavailable",
        popupSubtitle:
          "Unable to process your downgrade. Contact support@roconpaas.com for help.",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Let's Connect",
        popupCancelTitle: "Close",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          window.open("https://support.roconpaas.com/", "_blank");
          setPopup({ popupState: false });
        },
      });
    } else if (type === "success-upgrade") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Plan Upgrade Successful!",
        popupSubtitle:
          "Your organization is now upgraded. Enjoy your new features!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          navate(`/account/${orgId}/dashboard`);
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error-upgrade") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Plan Upgrade Failed!",
        popupSubtitle: "Please try again or contact support for assistance.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error-singlesite") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Plan Upgrade Failed!",
        popupSubtitle:
          "Switching plan types isn’t supported for upgrades. Please select a compatible option.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "no-upgrade") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Plan Upgrade Unavailable",
        popupSubtitle:
          "Unable to process your upgrade. Contact support@roconpaas.com for help.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "wait-popup") {
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Upgrade Delayed",
        popupSubtitle:
          "Plan can only be upgraded after 24 hours. Please try again later.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "no_permission") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "No Permission",
        popupSubtitle:
          "Plan can only be upgraded by Owner or Super Admin. Please contact them.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  const isplan =
    (basePlan && dedicatedHosting === true) ||
    (basePlan && dedicatedHosting === false);

  if (showModifyPlanPage) {
    return (
      <>
        {loading ? (
          <>
            <Grid2 className={ModifyPlanStyle.container}>
              <Grid2 className={ModifyPlanStyle.header}>
                {!isplan && (
                  <Grid2
                    onClick={handleBackToSelect}
                    className={ModifyPlanStyle.backButton}
                  >
                    <ArrowBackIcon />
                  </Grid2>
                )}
                {selectedGrid} Plans
              </Grid2>
              <Grid2 className={ModifyPlanStyle.time}>
                <Grid2 className={ModifyPlanStyle.ContainerYearOrMonth}>
                  <Grid2
                  className={
                      view === "Yearly"
                        ? ModifyPlanStyle.highlighted
                        : ModifyPlanStyle.nonHighlighted
                    }
                    style={{ left: view === "Yearly" ? 0 : "50%" }}
                    onClick={() => handleViewToggle("Yearly")}
                  >
                    Yearly
                  </Grid2>
                  <Grid2
                    className={
                      view === "Monthly"
                        ? ModifyPlanStyle.highlighted
                        : ModifyPlanStyle.nonHighlighted
                    }
                    style={{ left: view === "Monthly" ? 0 : "-50%" }}
                    onClick={() => handleViewToggle("Monthly")}
                  >
                    Monthly
                  </Grid2>
                </Grid2>
              </Grid2>

              {/* Plan Cards with shared sliderValue and handler */}
              <Grid2 className={ModifyPlanStyle.backgroundBox}>
                <Grid2 className={ModifyPlanStyle.planCardStyle}>
                  <PlanCard
                    planType="Solo-Site Plans"
                    subheader="Excellent if you manage 1 site"
                    allPlans={singleSitePlans}
                    billingType={view}
                    licenseData={planDetailsResult.licenseTrueType}
                    extractPricing={planDetailsResult.pricingTrue}
                    handleUpdateClick={handleUpdateClick}
                    isAgency={false}
                    downgradePopup={() => ActivatePopup("error")}
                    upgradePopupFunc={() => ActivatePopup("success-upgrade")}
                    upgradeFailPopupFunc={() => ActivatePopup("error-upgrade")}
                    singleSitePopupFunc={() =>
                      ActivatePopup("error-singlesite")
                    }
                    noUpgradePopupFunc={() => ActivatePopup("no-upgrade")}
                    agencyButton={() => ActivatePopup("info")}
                    waitPlanPopupFunc={() => ActivatePopup("wait-popup")}
                    noPermissionPopupFunc={() => ActivatePopup("no_permission")}
                    isSingleSite={true}
                    selectedLicenseType={
                      basePlan?.isSingleSite === true
                        ? basePlan.licenseType
                        : null
                    }
                    basePlan={basePlan}
                    specificPlan={specificPlan}
                    isProcessingCashfree={isProcessingCashfree}
                    selectedPlan={selectedPlan}
                    selectedOrg={selectedOrg}
                    country={country}
                    userDetails={userDetails}
                    selectedGrid={selectedGrid}
                  />
                  <PlanCard
                    planType="Multi-Site Plans"
                    subheader="Optimal when having two or more sites"
                    allPlans={singleSitePlans}
                    billingType={view}
                    licenseData={planDetailsResult.licenseFalseType}
                    extractPricing={planDetailsResult.pricingFalse}
                    handleUpdateClick={handleUpdateClick}
                    isAgency={false}
                    downgradePopup={() => ActivatePopup("error")}
                    upgradePopupFunc={() => ActivatePopup("success-upgrade")}
                    upgradeFailPopupFunc={() => ActivatePopup("error-upgrade")}
                    singleSitePopupFunc={() =>
                      ActivatePopup("error-singlesite")
                    }
                    noUpgradePopupFunc={() => ActivatePopup("no-upgrade")}
                    agencyButton={() => ActivatePopup("info")}
                    waitPlanPopupFunc={() => ActivatePopup("wait-popup")}
                    noPermissionPopupFunc={() => ActivatePopup("no_permission")}
                    isSingleSite={false}
                    selectedLicenseType={
                      basePlan?.isSingleSite === false
                        ? basePlan.licenseType
                        : null
                    }
                    basePlan={basePlan}
                    specificPlan={specificPlan}
                    isProcessingCashfree={isProcessingCashfree}
                    selectedPlan={selectedPlan}
                    selectedOrg={selectedOrg}
                    country={country}
                    userDetails={userDetails}
                    selectedGrid={selectedGrid}
                  />
                  {selectedGrid === "Dedicated Hosting" ? (
                    ""
                  ) : (
                    <PlanCard
                      planType="Agency Plans"
                      subheader="For large businesses"
                      allPlans={singleSitePlans}
                      billingType={view}
                      isAgency={true}
                      agencyButton={() => ActivatePopup("info")}
                    />
                  )}
                </Grid2>
              </Grid2>
            </Grid2>
          </>
        ) : (
          <PageLoading />
        )}

        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
          cancelTitle={popup.popupCancelTitle}
          cancelFunction={popup.popupCancelFunction}
        />
      </>
    );
  }

  return (
    <SelectPlan
      onSelect={handleGridSelect}
      plansInfo={loading}
      country={country}
      loading={loading}
    />
  );
};

export default ModifyPlan;
